import styled from '@emotion/styled';
import Checked from '@engineering/icons/checked';
import { Heading2 } from '@silvertours/front-shared';
import { AppLogo } from './AppLogo';

export const IllustrationWrapper = styled.div`
  grid-area: illustration;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;

  ${({ theme }) => theme.mq('md')} {
    width: fit-content;
    position: absolute;
    right: 0;
    top: 13rem;
  }

  ${({ theme }) => theme.mq('lg')} {
    position: static;
    margin: 1.75rem auto -2rem 0;
  }
`;

export const PictogramContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;

  svg {
    display: block;
    flex-shrink: 0;
    margin-left: calc(100% - 445px);
  }

  ${({ theme }) => theme.mq('md')} {
    overflow: visible;

    svg {
      margin-left: 0;
    }
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-areas:
    'content'
    'illustration';
  margin-bottom: -1rem;

  ${({ theme }) => theme.mq('sm')} {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mq('md')} {
    grid-template-areas: 'content illustration';
    grid-template-columns: 1fr auto;
    align-items: flex-start;
    padding-bottom: 6rem;
    margin-bottom: 1rem;
  }

  ${({ theme }) => theme.mq('lg')} {
    padding-bottom: 0;
    margin-bottom: -4rem;
  }
`;

export const ContentSection = styled.div`
  grid-area: content;
  gap: ${({ theme }) => theme.spacing[50]};

  ${({ theme }) => theme.mq('sm')} {
    grid-template-areas: 'text illustration';
    grid-template-columns: 1fr auto;
    align-items: center;
  }

  ${({ theme }) => theme.mq('md')} {
    grid-template-areas:
      'text'
      'illustration';
    grid-template-columns: 1fr;
    margin-top: -2rem;
  }
`;

export const PromoContainer = styled.div`
  border-radius: ${({ theme }) => theme.radius.sm};
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding: ${({ theme }) => theme.spacing[50]} 0
    ${({ theme }) => theme.spacing[50]} 0;

  ${({ theme }) => theme.mq('md')} {
    padding: ${({ theme }) => theme.spacing[60]} 0
      ${({ theme }) => theme.spacing[90]} 0;
  }

  ${({ theme }) => theme.mq('lg')} {
    padding: ${({ theme }) => theme.spacing[60]} 0
      ${({ theme }) => theme.spacing[80]} 0;
  }
`;

export const IntroSection = styled.div`
  display: grid;
  grid-template-areas:
    'logo'
    'title'
    'subtitle';
  gap: ${({ theme }) => theme.spacing[50]};
  margin: ${({ theme }) => theme.spacing[60]} 0 0;

  ${({ theme }) => theme.mq('sm')} {
    grid-template-areas:
      'logo title'
      'logo subtitle';
    grid-template-columns: auto 2fr;
  }
`;

export const Logo = styled(AppLogo)`
  grid-area: logo;
  height: 64px;
  width: auto;
`;

export const Info = styled.div`
  padding-left: 0.25rem;

  ${({ theme }) => theme.mq('sm')} {
    padding-left: 0;
  }
`;

export const Title = styled(Heading2)`
  grid-area: title;
  padding: 0 0 ${({ theme }) => theme.spacing[20]};
  margin: 0;
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: ${({ theme }) => theme.spacing[60]} 0 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[50]};

  ${({ theme }) => theme.mq('md')} {
    margin: ${({ theme }) => theme.spacing[60]} 0 0;
  }
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[30]};
  font-size: ${({ theme }) => theme.fontSize.sm.size};

  ${({ theme }) => theme.mq('lg')} {
    padding-right: ${({ theme }) => theme.spacing[40]};
  }
`;

export const FeatureDot = styled(Checked)`
  width: ${({ theme }) => theme.spacing[50]};
  height: ${({ theme }) => theme.spacing[50]};
  fill: currentcolor;
`;

export const StoreLinksContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[40]};
  flex-wrap: wrap;
  width: 100%;

  a {
    width: calc(50% - 8px);
    min-width: 140px;

    @media (max-width: 767px) {
      width: 100%;
    }
  }

  ${({ theme }) => theme.mq('sm')} {
    max-width: 336px;
  }
`;

export const DownloadsContainer = styled.div`
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.colors.neutral.grey40};
  background: ${({ theme }) => theme.colors.neutral.white100};
  box-shadow: 0 4px 28px 0 rgb(0 0 0 / 12%);
  padding: ${({ theme }) => theme.spacing[50]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[40]};
  width: 100%;

  ${({ theme }) => theme.mq('sm')} {
    flex-direction: row;
    max-width: fit-content;
    align-items: center;
  }
`;

export const AppPromoQrCode = styled.div`
  padding: 10px;
  width: 160px;
  height: 160px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const DesktopContainer = styled.div`
  display: none;

  ${({ theme }) => theme.mq('md')} {
    display: block;
  }
`;
